class FetchInterceptor {
    register({ onSuccess = () =>{}, onFailure = () =>{} }) {
        window.originalFetch = window.fetch;
        this.mockFetch = (...args) => (async(args) => {
            let result;
            try{
                result = await window.originalFetch(...args);
                result.ok ? onSuccess(result) : onFailure(result);
            }catch (e) {
                onFailure(e);
            }
            return result;
        })(args);
        window.fetch = this.mockFetch;
    }

    unregister(){
        if(window.originalFetch){
            window.fetch = window.originalFetch;
        }
    }
}

(function () {
    window.FetchInterceptor = FetchInterceptor;
})()